import { render } from "./BlockAndEvent.vue?vue&type=template&id=03bf3235"
import script from "./BlockAndEvent.vue?vue&type=script&lang=js"
export * from "./BlockAndEvent.vue?vue&type=script&lang=js"

import "./BlockAndEvent.vue?vue&type=style&index=0&id=03bf3235&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__